import { cn } from './utils';
import type { HorizonBand } from '../scoring/horizon-band.js';

/**
 * RUF-557 — color-coded chip for the passport/asset-detail horizon band
 * (packages/shared/src/scoring/horizon-band.ts). Mirrors ConditionBadge.tsx's
 * pill styling convention (`inline-flex ... rounded-full ... ring-1
 * ring-inset`) so band chips read consistently with the condition-band chip
 * already used on asset-detail headers, rather than inventing a new visual
 * language for one more enum.
 */

const LABELS: Record<HorizonBand, string> = {
  healthy: 'Healthy',
  degraded: 'Degraded',
  warning: 'Warning',
  critical: 'Critical',
};

const STYLES: Record<HorizonBand, string> = {
  healthy: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  degraded: 'bg-muted text-foreground ring-border',
  warning: 'bg-amber-50 text-amber-700 ring-amber-200',
  critical: 'bg-red-50 text-red-700 ring-red-200',
};

export function HorizonBandChip({ band }: { band: HorizonBand }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
        STYLES[band],
      )}
    >
      {LABELS[band]}
    </span>
  );
}
